module.exports = __webpack_public_path__ + "static/img/PHZ.6d1d22e3.png";